import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {Log} from 'ng2-logger';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {SampleRate} from "@app/strain/config/sample-rates/models/sample-rate.model";
import {MeasuringEquipment} from "@app/strain/config/measuring-equipment/models/measuring-equipment.model";
import {TranslateService} from "@ngx-translate/core";
import {StrainTestType} from '@app/strain/common/models/enum/strain-test-type.enum';
import {StrainMeasurementDetailsModel} from "@app/strain/common/models/view-measurement-models/strain-measurement-details.model";
import {StrainExecutionMode} from "@app/strain/common/models/enum/strain-execution-mode.enum";
import {User} from "@app/shared/models";

@Component({
    selector: 'app-strain-measurement-details-form',
    templateUrl: './strain-measurement-details-form.component.html',
    styleUrls: ['./strain-measurement-details-form.component.scss']
})
export class StrainMeasurementDetailsFormComponent implements OnInit, OnChanges {
    _logger = Log.create(StrainMeasurementDetailsFormComponent.name);

    @Input() frequencies: SampleRate[];
    @Input() measuringEquipment: MeasuringEquipment[];
    @Input() users: User[];
    @Input() isEditMode: boolean;
    @Input() strainMeasurementDetails: StrainMeasurementDetailsModel;
    @Input() showValidations = false;
    @Input() isLoading = false;
    @Input() measurementMethod: StrainExecutionMode;
    @Input() isManualMeasurement = false;

    public form: UntypedFormGroup;
    public measurementTypes: any[];
    public measurementMethods: any[];

    constructor(private fb: UntypedFormBuilder,
                private translate: TranslateService) {
        this.measurementTypes = Object.keys(StrainTestType).filter(item => isNaN(+item))
            .map((key) => {
                return {
                    name: this.translate.instant(`admin.strain.measurements.testTypes.${key}`),
                    value: StrainTestType[key]
                };
            });

        this.measurementMethods = Object.keys(StrainExecutionMode).filter(item => isNaN(+item))
            .map((key) => {
                return {
                    name: this.translate.instant(`admin.strain.measurements.executionModes.${key}`),
                    value: StrainExecutionMode[key]
                }
            });
    }

    ngOnInit() {
        this._logger.info("ngOnInit:: Preparing strain configuration form");

        this.initForm(this.isEditMode);
    }

    initForm(isEditMode) {
        this.showValidations = false;

        this.form = this.fb.group({
            measurementDate: [null, this.isManualMeasurement ? Validators.required : ''],
            measurementBy: [null, this.isManualMeasurement ? Validators.required : ''],
            frequency: [null, Validators.required],
            measuringEquipment: [null, Validators.required],
            responsible: [null, Validators.required],
            measurementType: [null, Validators.required],
            temperature: [null, Validators.required],
            humidity: [null, Validators.required],
            measurementMethod: [StrainExecutionMode[this.measurementMethod] ? {
                name: this.translate.instant(`admin.strain.measurements.executionModes.${StrainExecutionMode[this.measurementMethod]}`),
                value: this.measurementMethod,
            } : null, Validators.required],
        });

        if (isEditMode && this.strainMeasurementDetails) {
            this.load(this.strainMeasurementDetails);
        }
    }

    control(name: string): UntypedFormControl {
        return this.form.get(name) as UntypedFormControl;
    }

    value() {
        return this.form.value;
    }

    valid() {
        return this.form && this.form.valid;
    }

    reset() {
        this._logger.info("resetForm:: Resetting line details form");
        this.form.reset();
    }

    load(entry: StrainMeasurementDetailsModel) {
        this.form.setValue({
            measurementDate: null,
            measurementBy: null,
            frequency: entry.frequency,
            measuringEquipment: entry.measuringEquipment,
            responsible: entry.processResponsible,
            measurementType: {
                name: this.translate.instant(`admin.strain.measurements.testTypes.${StrainTestType[entry.measurementType]}`),
                value: entry.measurementType,
            },
            temperature: entry.temperature,
            humidity: entry.humidity,
            measurementMethod: {
                name: this.translate.instant(`admin.strain.measurements.executionModes.${StrainExecutionMode[entry.measurementMethod]}`),
                value: entry.measurementMethod,
            },
        });
    }


    ngOnChanges(changes: SimpleChanges): void {

    }

}
